import styled from 'styled-components'

export const FormContainer = styled.div``
